var _defs, _circle, _circle2, _g, _path, _circle3, _path2, _path3, _circle4, _path4, _path5, _circle5, _path6, _path7, _circle6, _path8, _path9, _circle7, _path10, _circle8, _path11;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStops = function SvgStops(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paradas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.36 226.38",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a1a8b5;opacity:.6;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-width:0px;}.cls-1,.cls-2,.cls-10,.cls-5{isolation:isolate;}.cls-2,.cls-8{fill:#5073b5;}.cls-3{fill:#c8e67f;}.cls-10{stroke:#929eb6;stroke-miterlimit:10;stroke-width:6px;}.cls-10,.cls-4{fill:none;}.cls-11{clip-path:url(#clippath-1);}.cls-12{clip-path:url(#clippath);}.cls-5,.cls-7{fill:#929eb6;}.cls-6{fill:#7b8fb5;}.cls-9{fill:#ffd25c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.99,
    cy: 113.62,
    r: 79.98
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -7.39,
    y: -7.19,
    width: 273.23,
    height: 273.23
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_110",
    className: "cls-6",
    cx: 112.29,
    cy: 113.63,
    r: 111.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 112.99,
    cy: 113.62,
    r: 79.98
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -7.39,
    y: -7.19,
    width: 273.23,
    height: 273.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "245.49 29.44 221.44 23.24 212.52 54.67 236.4 60.3 245.49 29.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "221.38 130.6 211.06 165.64 237.09 172.59 243.58 136.63 221.38 130.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "6.26 195.78 -7.39 220.45 -7.39 263.98 20.59 221.93 6.26 195.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "24.44 224.04 -3.51 266.04 50.98 266.04 67.69 238.53 24.44 224.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m-7.39,25.01l17.49,12.53,16.47,5.9,3.97-9.92c.3-3.89.59-7.52.86-10.93l-38.79-3.86v6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m33.79-7.19H-7.39V14.34l39.13,3.89c.86-10.81,1.52-19.08,2.05-25.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-7.39 107.08 25.53 115.93 33.99 94 -7.39 84.68 -7.39 107.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "43.93 68.26 22.31 62.29 -7.39 54.45 -7.39 80.19 35.59 89.87 43.93 68.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m36.13,32.1l19.44,5.17,5.2-21.36-23.18-2.31c-.51,6.37-1.01,12.74-1.46,18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m66.4-7.19h-27.13c-.41,5.04-.87,10.68-1.33,16.43l23.88,2.38,4.58-18.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.56 142.32 -7.39 135.66 -7.39 167.69 8.93 171.49 17.56 142.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-7.39 209.16 3.73 189.06 7.69 175.69 -7.39 172.18 -7.39 209.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "7.22 42.21 -7.39 31.73 -7.39 48.8 21.39 56.4 24.54 48.52 7.54 42.43 7.22 42.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m333.42,161.02l1.43-5.27-55.09-14.96,30.64-96.69c8.19-12.13,20.43-30.24,21.19-31.26l-4.37-3.28c-1.1,1.47-19.48,28.71-21.57,31.81l-.22.33-11.84,37.37-51.93-17.28,26.8-90.98-5.24-1.54-26.82,91.04-23.88-5.64,22.24-78.42-5.26-1.49-22.36,78.84-59.33-9.1-13.4-74.95-5.38.96,13.68,76.53-1.01,13.12-80.85-21.49,16.56-67.99-5.31-1.29-16.53,67.88-19.44-5.17c1.84-23.41,4.53-56.91,4.87-58.96-.03.15-.06.26-.08.31l-5.18-1.73c-.13.38-.47,1.4-5.2,61.8l-3.97,9.92-16.47-5.9L-77.03-24.9l-3.18,4.44L7.22,42.21l.31.22,17,6.09-3.15,7.88-45.53-12.03L-79.35,9.8l-2.9,4.63L-26.35,49.44l48.65,12.85,21.62,5.97-18.4,47.67-33.08-8.89-64.85-41.67-2.95,4.6L-11.69,110.88l-4.13,22.54,33.38,8.9-13.83,46.74-53.04,95.88,4.78,2.65L6.26,195.78l14.89,27.15,90.62,30.36c-3.36,18.51-5.74,31.59-5.91,32.38l2.67.58,2.67.59c.15-.69,2.55-13.84,5.81-31.8l56.46,18.92-4.41,14.98,5.24,1.54,4.36-14.79,39.24,13.15,1.74-5.18-39.43-13.21,6.62-22.46,25.08,8.2,33.5,26.38,3.38-4.29-34.26-26.98-26.16-8.55,21.17-71.86,117.36,31.3,1.41-5.28-117.23-31.27,10.32-35.04,112.04,30.42Zm-41.49-76.74l-17.45,55.08-51.55-14,17.18-58.33,51.82,17.25Zm-57.08-18.74l-17.2,58.38-23.01-6.25,16.38-57.75,23.82,5.62Zm-45.48,50.7l-45.55-12.37,4.14-53.83,57.67,8.85-16.27,57.35Zm-60.89,106.94l-5.42-1.59c5.4-29.82,10.98-60.66,12.74-70.37l40.58,10.82-19.93,70.28-27.96-9.14Zm8.28-77.36l5.41-31.1.94-5.38,44.78,12.16-10.01,35.29-41.11-10.97Zm2.73-56.85l-88.29-24.37,8-20.71,82.09,21.82-1.79,23.26ZM26.7,57.84l8.17-20.42,19.02,5.06-7.98,20.66-19.21-5.3Zm22.53,11.89l89.84,24.8-.85,11.06-6.75,38.82-100.63-27.05,18.39-47.63Zm33.29,67.18l-4.23,15.95-53.89-14.37,4.71-15.93,53.41,14.36Zm-92.05-7.47l3.02-16.46,30.35,8.16-4.72,15.94-28.65-7.64Zm91.7,30.11l5.63-21.22,42.72,11.48c-3.56,19.68-8.32,46-12.71,70.24l-108.13-31.78,13.17-44.54,59.32,15.82Zm-57.25,58.89l-13.06-23.83,104.97,30.85c-1.43,7.87-2.8,15.45-4.06,22.41l-87.84-29.43Zm150.09,50.29l-57.02-19.1c1.29-7.1,2.68-14.78,4.1-22.62l4.74,1.39,54.78,17.91-6.61,22.42Zm8.15-27.66l-21.5-7.03,20.02-70.57,22.57,6.02-21.09,71.57Zm22.63-76.82l-22.63-6.04,10-35.26,22.95,6.23-10.33,35.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m133,105.25l-4.45,25.6c-.66,3.8-4.44,6.21-8.16,5.21l-75.59-20.32c-3.76-1.01-5.82-5.06-4.42-8.69l9.85-25.52c1.21-3.14,4.61-4.86,7.86-3.96l70.26,19.39c3.02.83,5.03,3.7,4.79,6.82l-.07.85c-.02.21-.04.42-.08.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m144.21,25.03l-1.8,25.78c-.38,3.83-2.97,6.43-6.38,5.62l-69.32-16.41c-3.45-.82-5.53-4.75-4.47-8.45l7.44-25.99c.92-3.2,3.88-5.08,6.87-4.36l63.01,15.76c2.78.68,4.75,3.43,4.71,6.57v.85c-.01.21-.03.42-.05.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 187.87,
    y: -135.74,
    width: 5.46,
    height: 296.44,
    transform: "translate(130.97 193.94) rotate(-75.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 198.61,
    y: -144.49,
    width: 5.46,
    height: 296.44,
    transform: "translate(147.5 197.78) rotate(-75.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.58 79.13 199.78 99.6 222.99 105.81 229.01 85.37 205.58 79.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "234.85 65.54 211.03 59.93 206.18 77.03 229.63 83.28 234.85 65.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.65 117.68 217.65 123.93 222.38 107.9 199.18 101.7 194.65 117.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "188.15 72.23 192.15 56.83 170.98 53.58 167.56 66.75 188.15 72.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "145.11 87.24 143.83 103.88 154.88 106.88 159.02 90.96 145.11 87.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "168.81 53.25 147.97 50.05 147.1 61.3 165.45 66.18 168.81 53.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "164.9 68.3 146.93 63.51 145.28 85.02 159.57 88.84 164.9 68.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.13 91.52 156.99 107.46 177.55 113.04 181.71 97.03 161.13 91.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "189.71 74.91 184.37 95.48 194.5 98.18 200.3 77.73 189.71 74.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.9 75.62 205.64 58.9 194.32 57.16 190.26 72.79 200.9 75.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "179.66 113.61 189.37 116.25 193.9 100.29 183.82 97.59 179.66 113.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.68 89.41 182.26 94.91 187.6 74.34 167.01 68.86 161.68 89.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m176.38,162.05l-40.58-10.82c-.55,3.04-1.48,8.16-2.65,14.67l37.93,14.86,5.31-18.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m123.06,221.59l5.42,1.59,27.96,9.14,6.68-23.56-35.78-10.86c-1.39,7.69-2.85,15.72-4.29,23.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m170.47,182.87l-37.73-14.78c-1.42,7.82-3.15,17.38-5,27.65l35.98,10.92,6.75-23.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "142.17 114.73 136.76 145.83 177.87 156.79 187.88 121.51 143.11 109.35 142.17 114.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.49 88.97 141.28 65.71 126.63 61.82 118.31 83.13 139.49 88.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "93.04 76.15 101.26 55.07 80.15 49.46 72 70.34 93.04 76.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "51.2 64.6 69.88 69.76 78.02 48.89 59.2 43.89 51.2 64.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "116.19 82.54 124.51 61.25 103.39 55.64 95.15 76.73 116.19 82.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.88 42.48 34.86 37.42 26.7 57.84 45.91 63.14 53.88 42.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.28 152.86 82.51 136.91 50.54 128.31 46.79 144.46 78.28 152.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "29.1 122.55 24.39 138.48 44.68 143.89 48.42 127.74 29.1 122.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "23.83 121.13 -6.52 112.98 -9.54 129.44 19.11 137.08 23.83 121.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "43.44 149.22 22.84 143.73 17.36 162.23 38.91 168.77 43.44 149.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "67.49 179.73 61.95 203.63 85.64 210.6 91.14 186.91 67.49 179.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "40.51 171.54 34.91 195.69 59.85 203.01 65.39 179.09 40.51 171.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "65.89 176.96 70.64 156.47 45.56 149.78 41.01 169.41 65.89 176.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "16.74 164.32 9.66 188.27 32.81 195.07 38.41 170.9 16.74 164.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "91.63 184.78 101.55 142.02 87.79 138.33 82.16 159.55 72.75 157.04 67.99 177.6 91.63 184.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m122.48,194.14c2.89-15.99,5.71-31.56,8.02-44.34l-26.84-7.22-9.93,42.82,28.75,8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m87.74,211.21l30.05,8.83c1.41-7.79,2.86-15.8,4.3-23.73l-28.86-8.76-5.49,23.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "11.84 194.6 24.91 218.43 32.6 221.01 38.09 202.32 11.84 194.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "40.19 202.93 34.67 221.7 74.22 234.95 79.22 214.4 40.19 202.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m76.29,235.65l36.45,12.21c1.26-6.96,2.64-14.54,4.06-22.41l-35.49-10.43-5.03,20.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "204.24 169.48 181.66 163.46 176.19 182.76 197.82 191.24 204.24 169.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "168.96 208.25 190.85 214.9 197.2 193.35 175.59 184.88 168.96 208.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.65 234.02 183.15 241.05 190.24 217 168.36 210.36 161.65 234.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.11 129.17 193.16 122.94 183.15 158.2 205.78 164.24 216.11 129.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 104,
    y1: 136.28,
    x2: 104,
    y2: 136.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 222.93,
    y1: 202.26,
    x2: 222.93,
    y2: 202.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 39.94,
    y1: 199.92,
    x2: 39.94,
    y2: 199.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 80.95,
    y1: 211.94,
    x2: 80.95,
    y2: 211.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m205.2,195.63l-7.32,24.85c-3.35,11.38,2.95,23.36,14.23,27.05h0c2.45.8,4.73,2.02,6.76,3.62l8.1,6.38c3.87,3.05,8.65,4.7,13.57,4.7h.33c12.12,0,21.94-9.82,21.94-21.94v-34.57c0-9.94-6.68-18.63-16.28-21.2l-14.62-3.9c-11.49-3.07-23.33,3.59-26.7,15Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.66,167.6l.2.4.4.6,5.79,9.39c.4.8,1.6,1.2,2.4.6l.6-.6,5.79-10.58c.4-.8.8-2.4.8-3.2-.2-4.59-3.99-8.19-8.59-8.19-4.39-.2-8.19,3.39-8.39,7.99,0,1.2.4,2.6,1,3.59Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.25,
    cy: 163.41,
    r: 2.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m115.01,175.66l-2.17,3.94-.66.66c-.5.39-1.06.57-1.61.57-.2,0-.41-.02-.61-.07-.79-.19-1.46-.7-1.8-1.38l-2.34-3.8c-2.67.58-4.56,1.99-4.56,3.41,0,2.2,3.99,3.99,8.99,3.99s8.99-1.8,8.99-3.99c0-1.39-1.67-2.64-4.22-3.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.54,129.8l.2.4.4.6,5.79,9.39c.4.8,1.6,1.2,2.4.6l.6-.6,5.79-10.58c.4-.8.8-2.4.8-3.2-.2-4.59-3.99-8.19-8.59-8.19-4.39-.2-8.19,3.39-8.39,7.99,0,1.2.4,2.6,1,3.59Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.13,
    cy: 125.6,
    r: 2.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m65.9,137.85l-2.17,3.94-.66.66c-.5.39-1.06.57-1.61.57-.2,0-.41-.02-.61-.07-.79-.19-1.46-.7-1.8-1.38l-2.34-3.8c-2.67.58-4.56,1.99-4.56,3.41,0,2.2,3.99,3.99,8.99,3.99s8.99-1.8,8.99-3.99c0-1.39-1.67-2.64-4.22-3.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m99.56,60.3l.2.4.4.6,5.79,9.39c.4.8,1.6,1.2,2.4.6l.6-.6,5.79-10.58c.4-.8.8-2.4.8-3.2-.2-4.59-3.99-8.19-8.59-8.19-4.39-.2-8.19,3.39-8.39,7.99,0,1.2.4,2.6,1,3.59Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.15,
    cy: 56.11,
    r: 2.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m111.91,68.36l-2.17,3.94-.66.66c-.5.39-1.06.57-1.61.57-.2,0-.41-.02-.61-.07-.79-.19-1.46-.7-1.8-1.38l-2.34-3.8c-2.67.58-4.56,1.99-4.56,3.41,0,2.2,3.99,3.99,8.99,3.99s8.99-1.8,8.99-3.99c0-1.39-1.67-2.64-4.22-3.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m160.38,91.65l.2.4.4.6,5.79,9.39c.4.8,1.6,1.2,2.4.6l.6-.6,5.79-10.58c.4-.8.8-2.4.8-3.2-.2-4.59-3.99-8.19-8.59-8.19-4.39-.2-8.19,3.39-8.39,7.99,0,1.2.4,2.6,1,3.59Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 167.97,
    cy: 87.46,
    r: 2.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m172.73,99.71l-2.17,3.94-.66.66c-.5.39-1.06.57-1.61.57-.2,0-.41-.02-.61-.07-.79-.19-1.46-.7-1.8-1.38l-2.34-3.8c-2.67.58-4.56,1.99-4.56,3.41,0,2.2,3.99,3.99,8.99,3.99s8.99-1.8,8.99-3.99c0-1.39-1.67-2.64-4.22-3.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m145.31,151.63l.2.4.4.6,5.79,9.39c.4.8,1.6,1.2,2.4.6l.6-.6,5.79-10.58c.4-.8.8-2.4.8-3.2-.2-4.59-3.99-8.19-8.59-8.19-4.39-.2-8.19,3.39-8.39,7.99,0,1.2.4,2.6,1,3.59Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 152.9,
    cy: 147.44,
    r: 2.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m157.66,159.69l-2.17,3.94-.66.66c-.5.39-1.06.57-1.61.57-.2,0-.41-.02-.61-.07-.79-.19-1.46-.7-1.8-1.38l-2.34-3.8c-2.67.58-4.56,1.99-4.56,3.41,0,2.2,3.99,3.99,8.99,3.99s8.99-1.8,8.99-3.99c0-1.39-1.67-2.64-4.22-3.33Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 112.29,
    cy: 113.63,
    r: 81.11
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m27.41,20.32h169.76v169.76H27.41V20.32Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStops);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "stops.37dffe811be872e366a795b7a09efdf3.svg";